import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { login, setLoggedIn, isLoggedIn } from '../auth';
import './Login.css';

const EyeIcon = ({ show }) => show ? (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
) : (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const Login = () => {
  const [formUser, setFormUser]   = useState('');
  const [formPass, setFormPass]   = useState('');
  const [showPass, setShowPass]   = useState(false);
  const [error, setError]         = useState('');
  const navigate  = useNavigate();
  const location  = useLocation();

  useEffect(() => {
    if (isLoggedIn()) navigate('/', { replace: true });
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login(formUser, formPass)) {
      setLoggedIn(true);
      navigate(location.state?.from?.pathname || '/', { replace: true });
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">

        <div className="login-brand">
          <div className="login-logo">GM</div>
          <div>
            <div className="login-brand-name">GrayMatrix</div>
            <div className="login-brand-product">Automation Console</div>
          </div>
        </div>

        <div className="login-divider" />

        <p className="login-tagline">
          Sign in to manage your office lighting and automation.
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <label className="login-label">
            Username
            <input
              type="text"
              value={formUser}
              onChange={e => setFormUser(e.target.value)}
              autoComplete="username"
              className="login-input"
              placeholder="Enter username"
            />
          </label>

          <label className="login-label">
            Password
            <div style={{ position: "relative" }}>
              <input
                type={showPass ? "text" : "password"}
                value={formPass}
                onChange={e => setFormPass(e.target.value)}
                autoComplete="current-password"
                className="login-input"
                placeholder="Enter password"
                style={{ paddingRight: 40, width: "100%" }}
              />
              <button
                type="button"
                onClick={() => setShowPass(v => !v)}
                style={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "transparent",
                  border: "none",
                  color: "#555",
                  cursor: "pointer",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                }}
                tabIndex={-1}
              >
                <EyeIcon show={showPass} />
              </button>
            </div>
          </label>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-button">
            Sign In
          </button>
        </form>

        <div className="login-footer">
          Gray Matrix Solutions Pvt. Ltd.<br />
          Access restricted to authorized personnel only.
        </div>
      </div>
    </div>
  );
};

export default Login;
